import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Container, PageHeader } from '../../common';
import ChildInformationForm from './ChildInformationForm';
import ChildDetails from './ChildDetails';

class ChildInformationPage extends React.Component {
  state = {
    isEditing: false,
  };

  handleEdit = () => {
    this.setState({
      isEditing: true,
    });
  };

  handleCancel = () => {
    this.setState({
      isEditing: false,
    });
  };

  render() {
    const { isLoading, onContinue, onSave, patient } = this.props;
    const { isEditing } = this.state;

    const shouldShowForm = isEmpty(patient.firstName) || isEditing;

    return (
      <Container>
        <PageHeader
          onEdit={this.handleEdit}
          shouldShowEdit={!shouldShowForm}
          title="Child's Information"
        />
        {!!isLoading && isEmpty(patient.firstName) ? (
          <div>Loading...</div>
        ) : shouldShowForm ? (
          <ChildInformationForm
            {...patient}
            isEditing={isEditing}
            onCancel={this.handleCancel}
            onContinue={onContinue}
            onSave={onSave}
          />
        ) : (
          <ChildDetails {...patient} />
        )}
      </Container>
    );
  }
}

ChildInformationPage.propTypes = {
  onContinue: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  patient: PropTypes.object,
};

export default ChildInformationPage;



// WEBPACK FOOTER //
// ./src/modules/ChildInformationPage/components/ChildInformationPage.js